import type { AuthStateType } from '@/shared/authentication';

class operationsGetParameters {
  agencyName: string;
  bindingRequirements = false;
  userName: string | null = null;
  userRole: AuthStateType | null = null;

  constructor(agencyName: string) {
    this.agencyName = agencyName;
  }
}

function agencyOperationsParams(agencyName: string) {
  return new operationsGetParameters(agencyName);
}

function agencyOperationsWithBindingRequirementsParams(agencyName: string) {
  const parameters = agencyOperationsParams(agencyName);
  parameters.bindingRequirements = true;
  return parameters;
}

export {
  operationsGetParameters,
  agencyOperationsParams,
  agencyOperationsWithBindingRequirementsParams
};
